/**
 * FUTUMEDICA OFICIAL — LÓGICA DE TIENDA Y EXPERIENCIA DE USUARIO
 * Carrito Lateral AJAX (Free Shipping $200.000 COP), Quick View Modal, FAQ Modal, Mobile Drawer
 */

const FREE_SHIPPING_THRESHOLD = 200000; // $200.000 COP

// --- 1. CARRITO LATERAL (CART DRAWER) ---
function openCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartDrawerOverlay') || document.getElementById('cartOverlay');
  if (drawer) {
    drawer.classList.add('is-open', 'active');
  }
  if (overlay) {
    overlay.classList.add('is-open', 'active');
  }
  document.body.style.overflow = 'hidden';
  refreshCartDrawer();
}
window.openCart = openCartDrawer;
window.openCartDrawer = openCartDrawer;

function closeCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartDrawerOverlay') || document.getElementById('cartOverlay');
  if (drawer) {
    drawer.classList.remove('is-open', 'active');
  }
  if (overlay) {
    overlay.classList.remove('is-open', 'active');
  }
  document.body.style.overflow = '';
}
window.closeCart = closeCartDrawer;
window.closeCartDrawer = closeCartDrawer;

window.futumedicaCurrentCart = null;

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      window.futumedicaCurrentCart = cart;
      renderCartDrawerUI(cart);
    })
    .catch(err => console.error('Error al obtener carrito:', err));
}

// Inicializar el carrito al cargar la página para tener los datos listos
document.addEventListener('DOMContentLoaded', function() {
  refreshCartDrawer();
});

window.showFutumedicaToast = function(message) {
  var existingToast = document.getElementById('futumedica-toast');
  if (existingToast) existingToast.remove();

  var toast = document.createElement('div');
  toast.id = 'futumedica-toast';
  toast.innerHTML = `
    <div style="display:flex; align-items:center; gap:12px;">
      <svg viewBox="0 0 24 24" width="22" height="22" stroke="currentColor" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      <span style="font-size:14px; font-weight:500; line-height: 1.4;">${message}</span>
    </div>
  `;
  toast.style.position = 'fixed';
  toast.style.bottom = '40px';
  toast.style.left = '50%';
  toast.style.transform = 'translateX(-50%) translateY(100px)';
  toast.style.backgroundColor = '#861e56'; // Futumédica primary dark
  toast.style.color = 'white';
  toast.style.padding = '14px 20px';
  toast.style.borderRadius = '10px';
  toast.style.boxShadow = '0 10px 25px rgba(134, 30, 86, 0.4)';
  toast.style.zIndex = '999999';
  toast.style.transition = 'transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity 0.5s ease';
  toast.style.opacity = '0';
  toast.style.maxWidth = '90%';
  toast.style.width = 'max-content';

  document.body.appendChild(toast);

  // Trigger anim
  setTimeout(function() {
    toast.style.transform = 'translateX(-50%) translateY(0)';
    toast.style.opacity = '1';
  }, 50);

  // Auto hide
  setTimeout(function() {
    toast.style.transform = 'translateX(-50%) translateY(100px)';
    toast.style.opacity = '0';
    setTimeout(function() {
      if(toast.parentNode) toast.parentNode.removeChild(toast);
    }, 500);
  }, 4500);
};

window.checkInventoryLimit = function(variantId, qtyToAdd, maxInventory) {
  if (!maxInventory || maxInventory >= 99) return true; // No hay límite estricto
  var currentInCart = 0;
  if (window.futumedicaCurrentCart && window.futumedicaCurrentCart.items) {
    var item = window.futumedicaCurrentCart.items.find(i => i.variant_id == variantId || i.id == variantId);
    if (item) currentInCart = item.quantity;
  }
  if ((currentInCart + qtyToAdd) > maxInventory) {
    var msg = "¡Lo sentimos! Actualmente solo tenemos <strong>" + maxInventory + "</strong> unidades en bodega y ya están todas en tu carrito.";
    if (typeof showFutumedicaToast === 'function') {
      showFutumedicaToast(msg);
    } else {
      alert("¡Lo sentimos! Actualmente solo tenemos " + maxInventory + " unidades en bodega y ya están todas en tu carrito.");
    }
    return false;
  }
  return true;
};

function renderCartDrawerUI(cart) {
  var badges = document.querySelectorAll('#cartCount, .cart-badge, .cart-count-badge, #cartDrawerCount');
  badges.forEach(function(b) {
    b.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
    if (b.classList.contains('cart-badge') || b.id === 'cartCount') {
      b.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    }
  });

  var totalCOP = cart.total_price / 100;
  var formattedTotal = '$' + totalCOP.toLocaleString('es-CO') + ' COP';

  var subtotalEl = document.getElementById('cartSubtotal') || document.getElementById('drawerSubtotalAmount');
  var totalEl = document.getElementById('cartTotalPrice');
  if (subtotalEl) subtotalEl.textContent = formattedTotal;
  if (totalEl) totalEl.textContent = formattedTotal;

  var shippingMsg = document.getElementById('shippingMsg') || document.getElementById('freeShippingText');
  var shippingBar = document.getElementById('shippingProgressFill') || document.getElementById('freeShippingProgressBar');
  var shippingBadge = document.getElementById('cartShippingBadge');

  if (shippingMsg && shippingBar) {
    if (totalCOP >= FREE_SHIPPING_THRESHOLD) {
      shippingMsg.innerHTML = '🎉 <strong>¡Felicitaciones! Tienes ENVÍO GRATIS asegurado</strong>';
      shippingBar.style.width = '100%';
      shippingBar.style.background = '#2A9D8F';
      if (shippingBadge) {
        shippingBadge.textContent = '¡Gratis!';
        shippingBadge.style.color = '#2A9D8F';
      }
    } else {
      var missing = Math.round(FREE_SHIPPING_THRESHOLD - totalCOP);
      var percent = Math.min(100, Math.round((totalCOP / FREE_SHIPPING_THRESHOLD) * 100));
      shippingMsg.innerHTML = 'Agrega <strong>$' + missing.toLocaleString('es-CO') + ' COP</strong> más para <strong>Envío Gratis</strong>';
      shippingBar.style.width = percent + '%';
      shippingBar.style.background = '#9d2965';
      if (shippingBadge) {
        shippingBadge.textContent = 'Calculado al pagar';
        shippingBadge.style.color = '#64748b';
      }
    }
  }

  var emptyEl = document.getElementById('emptyCart') || document.getElementById('drawerEmptyState');
  var listEl = document.getElementById('cartItemsRendered') || document.getElementById('drawerCartItems');
  var footerEl = document.getElementById('cartFooter') || document.getElementById('drawerFooter');

  if (cart.item_count === 0) {
    if (emptyEl) emptyEl.style.display = 'block';
    if (listEl) listEl.innerHTML = '';
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (emptyEl) emptyEl.style.display = 'none';
  if (footerEl) footerEl.style.display = 'flex';

  if (listEl) {
    listEl.innerHTML = cart.items.map(function(item, idx) {
      var itemPrice = (item.final_price / 100).toLocaleString('es-CO');
      var img = item.image ? item.image : 'https://placehold.co/100x100/fbf5f7/9d2965?text=Futumedica';
      return (
        '<div class="cart-item-row" data-line="' + (idx + 1) + '">' +
          '<div class="cart-item-img-box">' +
            '<img src="' + img + '" alt="' + item.title + '">' +
          '</div>' +
          '<div class="cart-item-details">' +
            '<h4>' + item.product_title + '</h4>' +
            (item.variant_title ? '<span class="cart-item-variant">' + item.variant_title + '</span>' : '') +
            (item.properties && item.properties._alerta ? '<span class="cart-item-alert" style="display:inline-block; font-size:0.75rem; color:#d9534f; font-weight:600; margin-top:4px;">' + item.properties._alerta + '</span>' : '') +
            '<div class="cart-item-price-val">$' + itemPrice + ' COP</div>' +
            '<div class="cart-item-qty-row">' +
              '<div class="cart-item-qty-ctrl">' +
                '<button type="button" class="cart-item-qty-btn" onclick="updateCartItemQty(' + (idx + 1) + ', ' + (item.quantity - 1) + ')">-</button>' +
                '<span class="cart-item-qty-num">' + item.quantity + '</span>' +
                '<button type="button" class="cart-item-qty-btn" onclick="updateCartItemQty(' + (idx + 1) + ', ' + (item.quantity + 1) + ')">+</button>' +
              '</div>' +
              '<button type="button" class="cart-item-del-btn" onclick="updateCartItemQty(' + (idx + 1) + ', 0)" aria-label="Eliminar producto">' +
                '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }
}

function updateCartItemQty(line, newQty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: newQty })
  })
  .then(res => {
    if (!res.ok) {
      return res.json().then(err => { throw err; });
    }
    return res.json();
  })
  .then(cart => {
    renderCartDrawerUI(cart);
  })
  .catch(err => {
    console.error('Error al actualizar item:', err);
    var errorMsg = err.description || '¡Lo sentimos! No hay suficiente stock de este producto.';
    if (typeof window.showFutumedicaToast === 'function') {
      window.showFutumedicaToast(errorMsg);
    } else {
      alert(errorMsg);
    }
    refreshCartDrawer();
  });
}

function addItemToCartAJAX(variantId, qty = 1, price = null) {
  if (price !== null && parseFloat(price) <= 0) {
    alert('Este producto requiere asesoría técnica especializada y cotización previa.');
    return;
  }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
  .then(res => {
    if (!res.ok) {
      return res.json().then(err => { throw err; });
    }
    return res.json();
  })
  .then(item => {
    openCartDrawer();
  })
  .catch(err => {
    console.error('Error al añadir al carrito:', err);
    var errorMsg = err.description || '¡Lo sentimos! No hay suficiente stock de este producto.';
    if (typeof window.showFutumedicaToast === 'function') {
      window.showFutumedicaToast(errorMsg);
    } else {
      alert(errorMsg);
    }
  });
}

// --- 2. MODAL DE VISTA RÁPIDA (QUICK VIEW) ---
// La lógica avanzada de Quick View y validaciones de inventario se encuentra ahora en snippets/quick-view-modal.liquid y snippets/card-product.liquid

// --- 3. MODAL DE PREGUNTAS FRECUENTES (FAQ) ---
function openFaqModal() {
  const modal = document.getElementById('faqModalOverlay');
  if (modal) {
    modal.classList.add('active', 'is-active', 'is-open');
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
}
window.openFaqModal = openFaqModal;

function closeFaqModal(e) {
  if (e && e.target !== document.getElementById('faqModalOverlay') && !e.target.closest('.faq-modal-close-btn') && !e.target.closest('#closeFaqModalBtn') && !e.target.closest('.modal-close-btn')) {
    return;
  }
  const modal = document.getElementById('faqModalOverlay');
  if (modal) {
    modal.classList.remove('active', 'is-active', 'is-open');
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
}
window.closeFaqModal = closeFaqModal;

// --- 4. MENÚ MÓVIL DRAWER ---
function openFutumedicaMenu() {
  const overlay = document.getElementById('mobileNavOverlay');
  const drawer = document.getElementById('mobileNavDrawer');
  if (overlay && drawer) {
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
}

function closeFutumedicaMenu() {
  const overlay = document.getElementById('mobileNavOverlay');
  const drawer = document.getElementById('mobileNavDrawer');
  if (overlay && drawer) {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

// --- 5. WIDGET FLOTANTE DE WHATSAPP ---
function toggleWhatsAppBox() {
  const widget = document.getElementById('whatsappFloatingWidget');
  if (widget) {
    widget.classList.toggle('active');
  }
}
window.toggleWhatsAppBox = toggleWhatsAppBox;

// Inicializar al cargar el DOM
document.addEventListener('DOMContentLoaded', () => {
  // Cargar contador inicial del carrito
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const badges = document.querySelectorAll('#cartCount, .cart-badge, .cart-count-badge, .header-cart-badge');
      badges.forEach(b => {
        b.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
        b.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
    })
    .catch(() => {});

  // Asegurar que cualquier botón de carrito abra el drawer sin navegar
  const cartButtons = document.querySelectorAll('#openCartBtn, .cart-icon-btn, #cart-icon-bubble');
  cartButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  });
});

// --- 6. PAGINACIÓN AJAX DEL BLOG ---
document.addEventListener('DOMContentLoaded', function() {
  initAjaxBlogPagination();
});

function initAjaxBlogPagination() {
  document.body.addEventListener('click', function(e) {
    const paginationLink = e.target.closest('.blog-articles-grid-section .pagination-wrapper a, .blog-articles-grid-section .pagination__item');
    if (paginationLink && paginationLink.tagName.toLowerCase() === 'a') {
      e.preventDefault();
      const url = paginationLink.getAttribute('href');
      loadBlogPage(url);
    }
  });
}

function loadBlogPage(url) {
  const gridContainer = document.getElementById('blogCardsGrid');
  const paginationWrapper = document.querySelector('.blog-articles-grid-section .pagination-wrapper');
  
  if(gridContainer) gridContainer.style.opacity = '0.5';
  
  fetch(url)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newGrid = doc.getElementById('blogCardsGrid');
      const newPagination = doc.querySelector('.blog-articles-grid-section .pagination-wrapper');
      
      if(gridContainer && newGrid) {
        gridContainer.innerHTML = newGrid.innerHTML;
        gridContainer.style.opacity = '1';
      }
      
      if(paginationWrapper && newPagination) {
        paginationWrapper.innerHTML = newPagination.innerHTML;
      } else if (paginationWrapper && !newPagination) {
        paginationWrapper.innerHTML = '';
      }
      
      // Update URL without reload
      window.history.pushState({ path: url }, '', url);
      
      // Scroll to top of blog section smoothly
      const blogSection = document.querySelector('.blog-articles-grid-section');
      if(blogSection) {
        const topPos = blogSection.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: topPos, behavior: 'smooth' });
      }
    })
    .catch(err => {
      console.error('Error cargando página del blog:', err);
      window.location.href = url;
    });
}